export enum LocalRole {
  Admin = "ADMIN",
  Manager = "MANAGER",
  Doctor = "DOCTOR",
  Staff = "STAFF",
}
